import { createContext } from 'react';
import { SectionPermissionsContextValue } from '../types/Context';

const defaultSectionPermissions: SectionPermissionsContextValue = {
    scope: undefined,
    setScope: (_scope) => {},
    canView: (_scope) => false,
    canCreate: (_scope) => false,
    canEdit: (_id) => false,
    canDelete: (_id) => false,
    canPublish: (_id) => false,
    canReference: (_id) => false,
};

const SectionPermissionsContext = createContext(defaultSectionPermissions);

export default SectionPermissionsContext;